<template>
  <div>
    <v-card class="mx-auto mb-8 pa-6 page-break" elevation="3">
      <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">
        <CustomScenarioChart :period="otherValues.lifeExpectancy" category="age" />
      </div>
    </v-card>

    <v-card class="mx-auto mb-8 pa-6 page-break" elevation="3">
      <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">
        <div class="small-text-font mt-6">
          Your equity right now is approximately
          <span class="font-weight-bold">{{
            formatMoney(tableValues.finalValuesByNow.homeEquity)
            }}</span>. If your property value increases by approximately
          <span class="font-weight-bold">{{
            formatPercentage(selectedValues.propertyValueApreciationRate)
            }}</span>
          each year for the next
          <span class="font-weight-bold">{{ otherValues.lifeExpectancy }}</span> years, your equity
          in <span class="font-weight-bold">{{ otherValues.lifeExpectancy }}</span> years will be
          about: 
          <span class="font-weight-bold">{{
            formatMoney(tableValues.finalValuesByYears.homeEquity)
            }}</span>
          .......without making any mortgage payments.
        </div>

        <div class="my-4">
          <CustomPropertValueAppreciationRatesTable />
        </div>
        <NowVsFutureTableCDE finalRowLabel="Equity Change + Cash Savings" :preFinalRowLabel="`Estimated Total Cash Flow Impact, including immediate cash of ${formatMoney(
          tableValues.estimatedCashFlowImpact
        )}`" :preFinalRowValue="tableValues.estimatedTotalCashFlowImpact" />

      </div>
    </v-card>

    <v-card class="mx-auto mb-8 pa-6 page-break" elevation="3">
      <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">
        <div class="small-text-font mb-4">
          Is there a particular amount of equity you would like to have in
          <span class="font-weight-bold">{{ currentEffectiveYear }}</span>
          years?
        </div>
        <ChooseEquityTable />
      </div>

    </v-card>

    <v-card class="mx-auto mb-8 pa-6 page-break" elevation="3">
      <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">
        <CashFlowForCDEscenarios />
      </div>
    </v-card>
  </div>
</template>

<script>
import ChooseEquityTable from '@/components/Tables/ChooseEquityTable.vue';
import NowVsFutureTableCDE from '@/components/Tables/NowVsFutureTableCDE.vue';
import CustomScenarioChart from '@/components/Charts/CustomScenarioChart.vue';
import CashFlowForCDEscenarios from '@/components/Charts/CashFlowForCDEscenarios.vue';
import CustomPropertValueAppreciationRatesTable from '@/components/Tables/CustomPropertValueAppreciationRatesTable.vue';
import helpers from '@/helpers';

export default {
  components: {
    ChooseEquityTable,
    NowVsFutureTableCDE,
    CustomScenarioChart,
    CashFlowForCDEscenarios,
    CustomPropertValueAppreciationRatesTable
  },
  data: () => ({
    cashDisbursementOptions: [
      { value: true, text: 'Yes' },
      { value: false, text: 'No' }
    ]
  }),
  computed: {
    isResultSaved() {
      return this.$store.getters.isResultSaved;
    },
    otherValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;
    },
    selectedValues() {
      return this.$store.state.scenarioData.currentScenarioData.selectsOptions.selected;
    },
    tableValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.tableValues;
    },
    currentEffectiveYear() {
      return this.$store.state.scenarioData.currentScenarioData.selectsOptions.selected
        .effectiveAge;
    },
    isUpdating() {
      return this.$store.state.isUpdating;
    }
  },
  methods: {
    formatMoney: helpers.formatMoney,
    formatPercentage: helpers.formatPercentage,
    handleChange(value) {
      this.$store.commit('setCashDisbursementState', value);
    }
  }
};
</script>

<style scoped>
.page-break {
  break-inside: avoid;
  page-break-inside: avoid;
}

@media print {
  .page-break {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>
